import utility from './utility'

const global = {
    init: function() {
        [...document.querySelectorAll("input[name='CTXCvv']")].map(item => {
            item.onkeydown = (e) => utility.validateNumber(e);
        });

        const multidrawPopup = document.querySelector("#global--multidraw-notification-popup");
        if (multidrawPopup) {
            multidrawPopup.querySelector("#global--multidraw-notification-close").onclick = () => {
                utility.hidePopups();
            };
            multidrawPopup.querySelector("#global--multidraw-notification-remind").onclick = () => {
                const btn = document.querySelector("#global--multidraw-notification-remind");
                const ajaxOptions = {
                    url: "/api/web/account/multidraw-remind",
                    method: "POST",
                    data: "orderItemId=" + btn.dataset.id,
                    success: function(e) {
                        utility.hidePopups();
                    },
                    always: function() {
                        utility.enableButton(document.querySelector("#account--change-password-form button[type=submit]"));
                    }
                };
                utility.disableButton(btn);
                utility.ajaxRequest(ajaxOptions);
            };
            multidrawPopup.querySelector("#global--multidraw-notification-play").onclick = () => {
                utility.disableButton(document.querySelector("#global--multidraw-notification-play"));
            };
        }
        const signoutPopupClose = document.getElementById("global--signout-popup-close");
        if (signoutPopupClose) {
            signoutPopupClose.onclick = () => {
                utility.hidePopups();
            };
        }

        global.bindRemoveCartItemEvents();
        global.bindClearCart();
        global.addCheckoutMultiplier();
        global.deleteCheckoutMultiplier();
        global.addCheckoutJoker();
        global.deleteCheckoutJoker();
    },

    updateCartSummary: function(callback) {
        // update count
        utility.ajaxRequest({
            url: "/api/web/lottery/get-cart-count",
            method: "GET",
            success: function(e) {
                var result = JSON.parse(e.target.responseText);
                const element = document.getElementById("header-cart-count");
                const numItems = parseInt(result.numItems);
                if (numItems > 0) {
                    element.innerHTML = result.numItems;
                    element.style.display = null;
                }
                else {
                    element.innerHTML = "";
                    element.style.display = "none";
                }
            }
        });

        // update cart items
        utility.ajaxRequest({
            url: "/api/web/lottery/get-cart-header",
            method: "GET",
            success: function(e) {
                document.getElementById("header-cart-desktop").innerHTML = e.target.responseText;
                document.getElementById("header-cart-mobile").innerHTML = e.target.responseText;
                global.bindRemoveCartItemEvents();
                global.bindClearCart();
                if (callback) {
                    callback();
                }
            }
        });
    },

    bindClearCart: function () {
        [...document.querySelectorAll(".empty-cart")].map(item => {
            item.onclick = () => {
                utility.showPopup(document.querySelector("#account--empty-cart"));
            };
        });
        const checkoutClearCart = document.getElementById("account--empty-cart-yes");
        if (checkoutClearCart) {
            checkoutClearCart.onclick = (e) => {
                utility.disableButton(e.currentTarget);
                utility.ajaxRequest({
                    url: "/api/web/checkout/delete-cart",
                    method: "POST",
                    responseType: "text",                    
                    success: function (e) {
                        window.location.reload(true);
                    },
                    error: function (e) {
                        utility.disableButton(document.getElementById("account--empty-cart-yes"));
                    }
                });
            };
        }

        const checkoutCancelClearCart = document.getElementById("account--empty-cart-no");
        if (checkoutCancelClearCart) {
            checkoutCancelClearCart.onclick = (e) => {
                utility.hidePopups();
            };
        }
    },


    bindRemoveCartItemEvents: function() {
        [...document.querySelectorAll(".remove-cart-item")].map(item => {
            item.onclick = () => {
                utility.ajaxRequest({
                    url: "/api/web/checkout/delete-item",
                    method: "POST",
                    responseType: "text",
                    data: "itemId=" + item.dataset.itemid,
                    success: function(e) {
                        window.location.reload(true);
                    }
                });
            };
        });
    },

    addCheckoutMultiplier: function () {
            [...document.querySelectorAll(".add-multi")].map(item => {
                item.onclick = () => {
                    utility.ajaxRequest({
                        url: "/api/web/checkout/set-multiplier",
                        method: "POST",
                        responseType: "text",
                        data: "itemId=" + item.dataset.multi,
                        success: function (e) {
                            window.location.reload(true);
                        }
                    });
                };
            });
    },

    addCheckoutJoker: function () {
        [...document.querySelectorAll(".add-joker")].map(item => {
            item.onclick = () => {
                utility.ajaxRequest({
                    url: "/api/web/checkout/set-extra",
                    method: "POST",
                    responseType: "text",
                    data: "itemId=" + item.dataset.joker,
                    success: function (e) {
                        window.location.reload(true);
                    }
                });
            };
        });
    },

    deleteCheckoutMultiplier: function () {
        [...document.querySelectorAll(".remove-multi")].map(item => {
            item.onclick = () => {
                utility.ajaxRequest({
                    url: "/api/web/checkout/delete-multiplier",
                    method: "POST",
                    responseType: "text",
                    data: "itemId=" + item.dataset.multi,
                    success: function (e) {
                        window.location.reload(true);
                    }
                });
            };
        });
    },

    deleteCheckoutJoker: function () {
        [...document.querySelectorAll(".remove-joker")].map(item => {
            item.onclick = () => {
                utility.ajaxRequest({
                    url: "/api/web/checkout/delete-extra",
                    method: "POST",
                    responseType: "text",
                    data: "itemId=" + item.dataset.joker,
                    success: function (e) {
                        window.location.reload(true);
                    }
                });
            };
        });
    }
}

export default global



// WEBPACK FOOTER //
// ./assets/src/js/classes/global.js